export default __webpack_public_path__ + "static/media/assignmentsIconHCSelected.e2384434.svg";